import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components/dc-icon';

export enum DcIcons {
	Access = 'access',
	AddCircle = 'add-circle',
	Cache = 'cache',
	Cancel = 'cancel',
	Check = 'check',
	Column = 'column',
	Common = 'Common',
	CopyFile = 'copy-file',
	CollapseAll = 'collapse-all',
	Close = 'close',
	Delete = 'delete',
	DeleteForever = 'delete-forever',
	Details = 'details',
	DetectSchema = 'detect-schema',
	DetectAnomalies = 'detect-anomalies',
	DeSelectAll = 'deselected-action',
	Edit = 'edit',
	ExpandAll = 'expand-all',
	Export = 'export',
	Filter = 'filter',
	FilterOff = 'filter-off',
	Flash = 'flash',
	FlashOff = 'flash-off',
	FixWizard = 'fix-wizard',
	Formula = 'formula',
	Group = 'group',
	Info = 'info',
	Input = 'input',
	Key = 'key',
	KeepOn = 'keep-active',
	KeepOff = 'keep-inactive',
	LockOpen = 'lock-open',
	LockClose = 'lock-close',
	MenuMoreOptionsHandle = 'menu-more-options-open-handle',
	MoveUp = 'move-up',
	MoveDown = 'move-down',
	MoveTop = 'move-top',
	MoveBottom = 'move-bottom',
	OpenInNewTab = 'open-in-new-tab',
	Output = 'output',
	Pending = 'pending',
	ProjectDetails = 'project-details',
	Publish = 'publish',
	ResetSelection = 'reset-selection',
	RunningTask = 'running-task',
	Ranking = 'ranking',
	ResetText = 'reset-text',
	Save = 'save',
	Settings = 'settings',
	Share = 'share',
	SelectAll = 'selected-action',
	ShareOff = 'share-off',
	SpellCheck = 'spell-check',
	StackedFormula = 'stacked-formula',
	StopAction = 'stop-action',
	TableRows = 'table-rows',
	Task = 'task',
	TestApi = 'test-api',
	Update = 'update',
	URLs = 'urls',
	User = 'user',
	View = 'view',
	ViewCarousel = 'view-carouse',
	Warning = 'warning',
	WarningMessage = 'warning-message',
}

@Injectable()
export class AppDcIcons extends AppIcons {
	private readonly path = './src/img';

	protected icons: IIcons = {
		[DcIcons.Access]: `${this.path}/common/key_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.AddCircle]: `${this.path}/common/add_circle_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Cache]: `${this.path}/common/memory_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Cancel]: `${this.path}/common/cancel_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Check]: `${this.path}/common/check_circle_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Column]: `${this.path}/common/view_column_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Common]: `${this.path}/genericsData-color-solo.svg`,
		[DcIcons.CopyFile]: `${this.path}/common/file_copy_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.CollapseAll]: `${this.path}/common/collapse_all_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Close]: `${this.path}/common/close_black_24dp.svg`,
		[DcIcons.Delete]: `${this.path}/common/delete_FILL0_wght400_GRAD0_opsz24.svg`,
		[DcIcons.DeleteForever]: `${this.path}/common/delete_forever_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Details]: `${this.path}/common/info_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.DetectSchema]: `${this.path}/common/schema_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.DetectAnomalies]: `${this.path}/common/verified_user_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.DeSelectAll]: `${this.path}/common/check_box_outline_blank_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Edit]: `${this.path}/common/edit_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.ExpandAll]: `${this.path}/common/expand_all_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Export]: `${this.path}/common/export_notes_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Filter]: `${this.path}/common/filter_alt_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.FilterOff]: `${this.path}/common/filter_alt_off_48dp.svg`,
		[DcIcons.Flash]: `${this.path}/common/flash_on_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.FlashOff]: `${this.path}/common/flash_off_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.FixWizard]: `${this.path}/common/wand_stars_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Formula]: `${this.path}/svg/icon-formula.svg`,
		[DcIcons.Group]: `${this.path}/common/groups_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Info]: `${this.path}/common/chat_info_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Input]: `${this.path}/common/input_circle_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Key]: `${this.path}/common/key_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.KeepOn]: `${this.path}/common/keep_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.KeepOff]: `${this.path}/common/keep_off_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.LockOpen]: `${this.path}/common/lock_open_right_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.LockClose]: `${this.path}/common/lock_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.MenuMoreOptionsHandle]: `${this.path}/common/more_vert_FILL0_wght400_GRAD0_opsz24.svg`,
		[DcIcons.MoveUp]: `${this.path}/common/arrow_up_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.MoveDown]: `${this.path}/common/arrow_down_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.MoveTop]: `${this.path}/common/arrow_top_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.MoveBottom]: `${this.path}/common/arrow_bottom_48dp_5F6368_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Save]: `${this.path}/common/save_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Settings]: `${this.path}/common/settings_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Share]: `${this.path}/common/share_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.SelectAll]: `${this.path}/common/check_box_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.ShareOff]: `${this.path}/common/share_off_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.SpellCheck]: `${this.path}/common/spellcheck_48dp_000000_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.StackedFormula]: `${this.path}/common/dc-formula.svg`,
		[DcIcons.StopAction]: `${this.path}/common/stop_circle_48dp_5F6368_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.TableRows]: `${this.path}/common/table_rows_narrow_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Task]: `${this.path}/common/task_48dp_5F6368_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.TestApi]: `${this.path}/common/experiment_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.OpenInNewTab]: `${this.path}/common/open_in_new_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Output]: `${this.path}/common/output_circle_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Pending]: `${this.path}/common/pending_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.ProjectDetails]: `${this.path}/common/folder_eye_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Publish]: `${this.path}/common/publish_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Ranking]: `${this.path}/datablock/sync_alt_48dp_5F6368_FILL0_wght500_GRAD0_opsz48.svg`,
		[DcIcons.ResetSelection]: `${this.path}/common/reset_settings_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.ResetText]: `${this.path}/common/rotate_auto_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.RunningTask]: `${this.path}/common/av_timer_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Update]: `${this.path}/common/update_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.URLs]: `${this.path}/common/http_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.User]: `${this.path}/common/person_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.View]: `${this.path}/common/visibility_24dp_FILL0_wght400_GRAD0_opsz24.svg`,
		[DcIcons.ViewCarousel]: `${this.path}/common/view_carousel_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Warning]: `${this.path}/common/warning_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.WarningMessage]: `${this.path}/common/emergency_home_48dp_000000_FILL0_wght400_GRAD0_opsz48.svg`,
	};
}
